import React from "react";
import { Button } from "../ui/button";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alertDialog";

export default function PlanChangedModal({ open, onAcknowledge, loading = false }) {
  return (
    <AlertDialog open={open} onOpenChange={() => {}}>
      <AlertDialogContent
        className="max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="text-lg font-semibold">
            Plan updated
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3 text-left">
            <p>
              Your company plan has been modified. Please login again to use ProTeams.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            type="button"
            className="w-full bg-[#078037] hover:bg-[#06602c]"
            onClick={onAcknowledge}
            disabled={loading}
          >
            {loading ? "Logging out..." : "OK"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
